//
import { locale } from '@signavio/i18n'
import { omit } from 'lodash'

import { DateUtils } from '@signavio/effektif-commons'

import organizationName from './organizationName'

export default function createActivation(registration) {
  const { user, ...rest } = registration
  return {
    ...user,
    ...omit(rest, 'organization'),
    timeZone: DateUtils.currentTimezone(),
    language: locale(),
    organizationName: organizationName(registration),
  }
}
